import Loadable from "react-loadable";

const LazyForms = Loadable({
  loader: () => import(/* webpackChunkName: 'job-promise' */ "./index"),
  loading: () => 'loading...'
});

export default LazyForms;
